import { CARGAR_CLIENTE, SET_CLIENTE, CARGAR_CHEQUES,
         INICIALIZAR_CLIENTE, CARGAR_NOTACREDITO, CARGAR_NOTADEBITO,
         INICIALIZAR_NOTACREDITO, INICIALIZAR_NOTADEBITO, CARGAR_GESTIONES_CLIENTE,
         CARGAR_GESTIONESPLANIF_CLIENTE
         } from '../actions/clientes/actionTypes';

const estadoInicial = {clientes:[], clienteSel: null, cheques: [], notaCreditoSel: {}, notaDebitoSel: {}, gestionesPlanif: []};

const clientesReducer = (state = estadoInicial, action) => {
    switch(action.type){
        case CARGAR_CLIENTE:
        case INICIALIZAR_CLIENTE:
        case SET_CLIENTE:
            return {...state, clienteSel: action.data };
        case CARGAR_CHEQUES:
            return {...state, cheques: action.data };
        case CARGAR_NOTACREDITO:
            return {...state, notaCreditoSel: action.data };
        case CARGAR_NOTADEBITO:
            return {...state, notaDebitoSel: action.data };
        case INICIALIZAR_NOTACREDITO:
            return {...state, notaCreditoSel: action.data };
        case INICIALIZAR_NOTADEBITO:
            return {...state, notaDebitoSel: action.data };
        case CARGAR_GESTIONES_CLIENTE:
            return {...state, clienteSel: {...state.clienteSel, gestiones: action.data}};
        case CARGAR_GESTIONESPLANIF_CLIENTE:
            return {...state, gestionesPlanif: action.data};
        default:
            return state;
    }
};

export default clientesReducer;